'use strict';

exports.__esModule = true;
exports.reducer = reducer;

var _reactisForms = require('reactis-forms');

var CLOSE = '@@Tab/Close';

function reducer(state, action) {
	switch (action.type) {
		case CLOSE:
			return state['delete']('tab_' + action.id);

		default:
			return _reactisForms.reducer(state, action);
	}
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/formTab.js
 ** module id = 1057
 ** module chunks = 2
 **/